import { isInApp, isPC, isInWeChatMiniProgram } from '@h5-journey/utils'

export const TRACK_PROJECT_KEY_NAME = 'track_project_key_name'

// 内存中存储的 source 值（普通 H5 环境用的自定义值；小程序/APP 环境由 resolveTrackSource 强制覆盖）
export let trackSource: string = 'web'

/**
 * 设置埋点 source（传入普通 H5 环境下的自定义值）
 * 注意：小程序/APP 环境下上报时会被 resolveTrackSource 强制覆盖为 wxapp/app
 */
export function setTrackSource(source: string) {
  trackSource = source
}

/**
 * 获取当前埋点 source
 */
export function getTrackSource(): string {
  return trackSource
}

/**
 * 按环境解析最终上报 source（严格规则，不可随意覆盖）：
 * 1. 微信小程序环境 → 'wxapp'
 * 2. APP 环境 → 'app'
 * 3. PC 桌面浏览器 → 'pc'
 * 4. 其余（移动端普通 H5）→ 自定义 source（不传则回退当前 trackSource）
 * 各应用只需传入普通 H5 环境下的自定义 source，小程序/APP/PC 环境会被强制覆盖以保证环境标识准确。
 */
export function resolveTrackSource(customSource?: string): string {
  if (isInWeChatMiniProgram()) return 'wxapp'
  if (isInApp()) return 'app'
  if (isPC()) return 'ZL_PC'  //pC 站埋点
  return customSource || trackSource
}
